// extracted by mini-css-extract-plugin
module.exports = {"selectContainer":"style_selectContainer__RWYjs","selectedItemContainer":"style_selectedItemContainer__VlswM","languageName":"style_languageName__lN_kB"};